import React from 'react'
import LogPage from '../../components_renew/common/LogPage'

const LotteryLog = () => {
  return <LogPage title={'中奖记录'} api={window.API.Turntable.getLotteryLog}>
  </LogPage>
}

export default LotteryLog
